import {
  API_BASE_URL,
  loginModal,
  googleLogin,
  auth,
  provider,
  usernameElement,
  loginToggle,
  menuToggle,
  chatHeaderImg,
  AppState // <-- Import AppState
} from './globals.js';
import { typeWriter } from './ui.js';
import { clearAllCachedData } from './data.js';

// ============================================
// SESSION ID GENERATION FUNCTION
// ============================================

export function generate27CharString() {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "web_"; // Start with "web_"
  
  for (let i = 0; i < 23; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    result += chars[randomIndex];
  }

  return result;
}

export function initializeSessionId() {
  let sessionId = localStorage.getItem("walleto_session_id");

  if (!sessionId) {
    sessionId = generate27CharString();
    localStorage.setItem("walleto_session_id", sessionId);
  }

  return sessionId;
}

// ============================================
// USER DATA FUNCTIONS
// ============================================

export async function sendUserDataToServer(userData) {
  try {
    // console.log("Sending user data to server:", userData);

    const response = await fetch(`${API_BASE_URL}/createUser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        uid: userData.user_uid,
        display_name: userData.display_name,
        email: userData.email,
        country: AppState.selectedCountryName, // updated
        photo_url: userData.photo_url || null,
        favourites: [],
        date_of_birth: null,
        phone_number: null,
        platform: "web"
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `HTTP error! status: ${response.status}, message: ${errorText}`,
      );
    }

    const result = await response.json();
    // console.log("User data stored successfully:", result);
    return result;
  } catch (error) {
    console.error("Error sending user data to server:", error);
    return null;
  }
}

// ============================================
// MOBILE MENU UI FUNCTION
// ============================================
export function updateMobileAuthUI(isLoggedIn, userName = "") {
  const mobileAuthSection = document.getElementById("mobileAuthSection");
  if (!mobileAuthSection) return;

  if (isLoggedIn) {
    mobileAuthSection.innerHTML = `
      <div style="text-align: center; margin-bottom: 15px; color: #444; font-weight: 600;">
        <i class="fas fa-user-circle"></i> ${userName}
      </div>
      <button class="menu-btn" id="mobileLogoutBtn" style="width: 100%; justify-content: center; background: rgba(220, 20, 60, 0.1); color: #dc143c;">
        <i class="fas fa-sign-out-alt"></i> Logout
      </button>
    `;
    document.getElementById("mobileLogoutBtn").addEventListener("click", () => {
      signOutUser();
      document.getElementById("mobileMenu").classList.remove("active");
    });
  } else {
    mobileAuthSection.innerHTML = `
      <button class="menu-btn" id="mobileLoginBtn" style="width: 100%; justify-content: center; background: #dc143c; color: white;">
        <i class="fas fa-sign-in-alt"></i> Login
      </button>
    `;
    document.getElementById("mobileLoginBtn").addEventListener("click", () => {
      document.getElementById("mobileMenu").classList.remove("active");
      openLoginModal();
    });
  }
}

// ============================================
// FIREBASE AUTH FUNCTIONS
// ============================================

export async function checkUserExists(uid) {
  try {
    const response = await fetch(
      `${API_BASE_URL}/userExists?uid=${encodeURIComponent(uid)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `HTTP error! status: ${response.status}, message: ${errorText}`,
      );
    }
    const data = await response.json();
    return data.exists;
  } catch (error) {
    console.error("Error checking user existence:", error);
    return false;
  }
}

export async function signInWithGoogle() {
  if (!auth) {
    alert("You are currently offline. Please connect to the internet to sign in.");
    return;
  }
  try {
    googleLogin.innerHTML = `<i class="fas fa-spinner fa-spin"></i> Redirecting to Google...`;
    googleLogin.disabled = true;

    await auth.signInWithRedirect(provider);
    
  } catch (error) {
    console.error("Google sign-in error:", error);
    alert(`Sign-in failed: ${error.message}`);

    googleLogin.innerHTML = `<i class="fab fa-google"></i> Continue with Google`;
    googleLogin.disabled = false;
  }
}

export async function signOutUser() {
  try {
    if (auth) {
      await auth.signOut();
    }
  } catch (error) {
    console.error("Sign out error:", error);
  } finally {
    localStorage.removeItem("user");
    await clearAllCachedData();
    window.location.reload(); 
  }
}

// ============================================
// LOGIN/LOGOUT FUNCTIONS
// ============================================

export function openLoginModal() {
  loginModal.classList.add("active");
  document.body.style.overflow = "hidden";
}

export function closeLoginModal() {
  loginModal.classList.remove("active");
  document.body.style.overflow = "";
  
  setTimeout(() => {
    const searchWrapper = document.querySelector('.hero-search-wrapper');
    if (searchWrapper) {
      searchWrapper.classList.add('animate-entrance');
    }
    setTimeout(typeWriter, 300);
  }, 200);
}

// function handleAppleLogin() {
//   console.log("Apple login clicked");
//   const originalContent = appleLogin.innerHTML;
//   appleLogin.innerHTML = `<i class="fas fa-spinner fa-spin"></i> Connecting...`;
//   appleLogin.disabled = true;

//   setTimeout(() => {
//     alert(
//       "Apple login is not yet implemented. Please use Google login for now.",
//     );
//     appleLogin.innerHTML = `<i class="fab fa-apple"></i> Continue with Apple`;
//     appleLogin.disabled = false;
//   }, 1000);
// }